import RootLayout from '../../layouts/Root/RootLayout'
import AdminHeader from './AdminHeader'
import routes from './routes'

const AdminLayout = (page) => <RootLayout HeaderComponent={AdminHeader} page={page} routes={routes} />

export default AdminLayout
